"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ListItem = _styledComponents.default.button.attrs({
  href: '#',
  type: 'button'
}).withConfig({
  displayName: "ListItem"
})(["display:block;width:100%;text-align:center;margin:0;padding:1rem;border:none;border-bottom:1px solid ", ";font-weight:700;font-size:", ";color:", ";cursor:pointer;&:hover{color:", ";}"], props => props.theme.palette.border, (0, _polished.rem)('14px'), props => props.theme.palette.text, props => props.theme.palette.primary[0]);

var _default = ListItem;
exports.default = _default;